import axios from "axios";

const login = (email, password)=>{
    return axios
        .post('https://coda.easylinksmw.com//api/admins/login', {
            email,
            password
        })
        .then((response)=>{
            if(response.data.accessToken){
                localStorage.setItem('user', JSON.stringify(response.data))
            }
        })
}

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem("user"));
  };

const authService = {
    login,
    getCurrentUser
}

export default authService